export const MAP_ERROR_SUCCESS = "MAP_ERROR_SUCCESS"
export const MAP_CLEAR_ERROR_SUCCESS = "MAP_CLEAR_ERROR_SUCCESS"